module.exports = __webpack_public_path__ + "static/media/klima-06.70b34c93.jpg";